/** @jsxRuntime classic */ /** @jsx createElement */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderCombobox_unstable", {
    enumerable: true,
    get: ()=>renderCombobox_unstable
});
const _reactPortal = require("@fluentui/react-portal");
const _reactJsxRuntime = require("@fluentui/react-jsx-runtime");
const _reactUtilities = require("@fluentui/react-utilities");
const _comboboxContext = require("../../contexts/ComboboxContext");
const renderCombobox_unstable = (state, contextValues)=>{
    const { slots , slotProps  } = (0, _reactUtilities.getSlotsNext)(state);
    return /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(slots.root, slotProps.root, /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(_comboboxContext.ComboboxContext.Provider, {
        value: contextValues.combobox
    }, /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(slots.input, slotProps.input), slots.expandIcon && /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(slots.expandIcon, slotProps.expandIcon), slots.listbox && (state.inlinePopup ? /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(slots.listbox, slotProps.listbox) : /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(_reactPortal.Portal, null, /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(slots.listbox, slotProps.listbox)))));
}; //# sourceMappingURL=renderCombobox.js.map

//# sourceMappingURL=renderCombobox.js.map